const FirstNameIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0057 7.16667C6.44303 7.16667 5.17236 5.89533 5.17236 4.33333C5.17236 2.77133 6.44303 1.5 8.0057 1.5C9.56836 1.5 10.839 2.77133 10.839 4.33333C10.839 5.89533 9.56836 7.16667 8.0057 7.16667ZM8.0057 2.5C6.99436 2.5 6.17236 3.322 6.17236 4.33333C6.17236 5.34467 6.99436 6.16667 8.0057 6.16667C9.01703 6.16667 9.83903 5.34467 9.83903 4.33333C9.83903 3.322 9.01636 2.5 8.0057 2.5ZM10.6643 14.5H5.33504C3.72171 14.5 2.83301 13.6167 2.83301 12.0127C2.83301 10.2387 3.83701 8.16667 6.66634 8.16667H9.33301C12.1623 8.16667 13.1663 10.238 13.1663 12.0127C13.1663 13.6167 12.2776 14.5 10.6643 14.5ZM6.66634 9.16667C4.03767 9.16667 3.83301 11.3447 3.83301 12.0127C3.83301 13.0554 4.28238 13.5 5.33504 13.5H10.6643C11.717 13.5 12.1663 13.0554 12.1663 12.0127C12.1663 11.3454 11.9617 9.16667 9.33301 9.16667H6.66634Z"
      fill="#888888"
    />
  </svg>
);
export default FirstNameIcon;
